import React from 'react';
import { Helmet } from 'react-helmet-async';

const SiteTitle = () => {
  // Favicon is set statically in index.html (/favicon.png) — no Helmet override
  // here. The previous dynamic <link rel="icon" href="/api/logos/${settings.favicon}">
  // was a multi-tenant DAO white-label hook; on RC it stacked with the static
  // tag and caused the wrong favicon to show whenever the backend returned a
  // legacy settings.favicon value inherited from DAO.
  return (
    <Helmet>
      <title>Retail Circle</title>
      <meta property="og:title" content="Retail Circle" />
    </Helmet>
  );
}

export default SiteTitle;
